import {
  Users,
  IndianRupee,
  Landmark,
  Wallet,
  BookOpen,
  type LucideIcon,
} from 'lucide-react';

export interface ModuleDef {
  id: string;
  name: string;
  tagline: string;
  description: string;
  icon: LucideIcon;
  bullets: string[];
}

export const MODULES: ModuleDef[] = [
  {
    id: 'students',
    name: 'Students',
    tagline: 'A single source of truth for every learner.',
    description:
      'Admissions, records, attendance, marks, parent contacts and class transitions — everything that matters about a student, in one calm page.',
    icon: Users,
    bullets: [
      'Bulk admissions and class-wise rosters',
      'Attendance, marks and report cards',
      'Parent portal with WhatsApp & SMS reach',
      'Year-rollover and bulk class promotions',
    ],
  },
  {
    id: 'fees',
    name: 'Fees',
    tagline: 'Collect, track and reconcile — without spreadsheets.',
    description:
      'Class-wise fee structures, term-wise dues, online payments, concessions, and receipt printing wired straight into the ledger.',
    icon: IndianRupee,
    bullets: [
      'Razorpay-powered online collection',
      'Class- and student-level concessions',
      'Configurable receipts (Tamil + English)',
      'Due reports filtered by class or term',
    ],
  },
  {
    id: 'finance',
    name: 'Finance',
    tagline: 'Double-entry accounting that respects accountants.',
    description:
      'Cash book, bank book, journal entries, party ledgers and statutory reports — built for the way Indian school accountants actually work.',
    icon: Landmark,
    bullets: [
      'Cash, bank and journal vouchers',
      'Trial balance, P&L and balance sheet',
      'Party-wise ledger with running balance',
      'Fee receipts auto-posted to accounts',
    ],
  },
  {
    id: 'payroll',
    name: 'Payroll',
    tagline: 'Salary runs that finish in minutes.',
    description:
      'Pay scales, attendance integration, leaves, pay slips and statutory deductions — generated, audited and distributed with confidence.',
    icon: Wallet,
    bullets: [
      'Configurable pay scales and grades',
      'Attendance- and leave-aware calculations',
      'Pay slips with one-click WhatsApp send',
      'Year-on-year salary history per employee',
    ],
  },
  {
    id: 'library',
    name: 'Library',
    tagline: 'Catalog, issue, return — without the index cards.',
    description:
      'Book masters, acquisitions, issues and returns, overdue tracking and member management — quiet, fast and barcode-friendly.',
    icon: BookOpen,
    bullets: [
      'Title, author and accession masters',
      'Issue / return with overdue tracking',
      'Member rosters for students & staff',
      'Purchase ledger with vendor history',
    ],
  },
];
